import { requestVerifyCode, requestVerifyUserId } from "./services";

export const OTP_AUTH_RESET_SESSION = "OTP_AUTH_RESET_SESSION";
export const OTP_AUTH_SET_ERROR = "OTP_AUTH_SET_ERROR";
export const OTP_AUTH_SET_USER_ID = "OTP_AUTH_SET_USER_ID";
export const OTP_AUTH_VERIFY_USER_ID_REQUESTED =
    "OTP_AUTH_VERIFY_USER_ID_REQUESTED";
export const OTP_AUTH_VERIFY_USER_ID_SUCCEEDED =
    "OTP_AUTH_VERIFY_USER_ID_SUCCEEDED";
export const OTP_AUTH_VERIFY_USER_ID_FAILED = "OTP_AUTH_VERIFY_USER_ID_FAILED";
export const OTP_AUTH_VERIFY_USER_ID = "OTP_AUTH_VERIFY_USER_ID";
export const OTP_AUTH_SET_VERIFICATION_CODE = "OTP_AUTH_SET_VERIFICATION_CODE";
export const OTP_AUTH_VERIFY_CODE_REQUESTED = "OTP_AUTH_VERIFY_CODE_REQUESTED";
export const OTP_AUTH_VERIFY_CODE_SUCCEEDED = "OTP_AUTH_VERIFY_CODE_SUCCEEDED";
export const OTP_AUTH_VERIFY_CODE_FAILED = "OTP_AUTH_VERIFY_CODE_FAILED";
export const OTP_AUTH_VERIFY_CODE = "OTP_AUTH_VERIFY_CODE";
export const OTP_AUTH_GO_TO_SCREEN = "OTP_AUTH_GO_TO_SCREEN";
export const OTP_AUTH_SET_LOADING = "OTP_AUTH_SET_LOADING";
export const OTP_AUTH_SET_IS_VALID = "OTP_AUTH_SET_IS_VALID";

export const resetSession = () => {
    return {
        type: OTP_AUTH_RESET_SESSION
    };
};

export const setError = (fieldId, error) => {
    let valid = false;
    if (error === "") {
        valid = true;
    }

    return {
        type: OTP_AUTH_SET_ERROR,
        payload: { id: fieldId, valid: valid, error: error }
    };
};

export const setLoading = isLoading => {
    return {
        type: OTP_AUTH_SET_LOADING,
        payload: isLoading
    };
};

export const setUserId = userId => {
    return {
        type: OTP_AUTH_SET_USER_ID,
        payload: userId
    };
};

export const setIsValid = isValid => {
    return {
        type: OTP_AUTH_SET_IS_VALID,
        payload: isValid
    };
};

export const verifyUserId = (userId) => {
    if (!userId) {
        return {
            type: OTP_AUTH_VERIFY_USER_ID
        };
    }
    if (userId.length < 6 || userId.length > 8) {
        return dispatch => {
            dispatch(
                setError(
                    "verify-user",
                    "User ID must be between 6-8 characters"
                )
            );
        };
    }

    return dispatch => {
        dispatch(setLoading(true));
        dispatch(goToAuthScreen("requireCode"));
        dispatch(userIdVerificationRequested(userId));
        return requestVerifyUserId(userId)
            .then(result => {
                dispatch(setLoading(false));
                dispatch(userIdVerificationSucceeded(result));
            })
            .catch(error => {
                dispatch(setLoading(false));
                dispatch(userIdVerificationFailed(error));
            });
    };
};

export const userIdVerificationRequested = userId => {
    return {
        type: OTP_AUTH_VERIFY_USER_ID_REQUESTED,
        payload: userId
    };
};

export const userIdVerificationSucceeded = (result) => {
    return {
        type: OTP_AUTH_VERIFY_USER_ID_SUCCEEDED,
        payload: result
    };
};

export const userIdVerificationFailed = error => {
    return {
        type: OTP_AUTH_VERIFY_USER_ID_FAILED,
        payload: error
    };
};

export const setVerificationCode = code => {
    return {
        type: OTP_AUTH_SET_VERIFICATION_CODE,
        payload: code
    };
};

export const verifyCode = (uuid, code, skipSuccessPage) => {
    if (!uuid) {
        return dispatch => {
            dispatch(codeVerificationFailed());
            return {
                type: OTP_AUTH_VERIFY_CODE
            };
        };
    }
    if (code.length !== 6) {
        return dispatch => {
            dispatch(
                setError("verify-code", "Verification code must be 6-digits")
            );
        };
    }

    return dispatch => {
        dispatch(setLoading(true));
        dispatch(codeVerificationRequested(uuid));

        return requestVerifyCode(uuid, code)
            .then(result => {
                dispatch(setIsValid(true));
                dispatch(setLoading(false));
                dispatch(codeVerificationSucceeded(result));
                if (!skipSuccessPage) {
                    dispatch(goToAuthScreen("successfulVerification"));
                }
            })
            .catch(error => {
                dispatch(setLoading(false));
                dispatch(codeVerificationFailed(error));
            });
    };
};

export const codeVerificationRequested = (uuid) => {
    return {
        type: OTP_AUTH_VERIFY_CODE_REQUESTED,
        payload: uuid
    };
};

export const codeVerificationSucceeded = result => {
    return {
        type: OTP_AUTH_VERIFY_CODE_SUCCEEDED,
        payload: result
    };
};

export const codeVerificationFailed = error => {
    return dispatch => {
        dispatch(
            setError(
                "verify-code",
                "That's not right. Either your 365 online ID is incorrect or your code is invalid. Please check the details you've entered and try again."
            )
        );

        return {
            type: OTP_AUTH_VERIFY_CODE_FAILED,
            payload: error
        };
    };
};

export const goToAuthScreen = screen => {
    window.dataLayer &&
        window.dataLayer.push({
            event: "screenChange",
            newscreenPath: `/sba/${screen}`
        });
    return {
        type: OTP_AUTH_GO_TO_SCREEN,
        payload: screen
    };
};
